<template>
  <DefaultLayout>
    <template #buttons>
      <CompanyCreateAction @created="reload" v-if="can('COMPANY_MANAGE')" />
    </template>

    <CompanyFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Companies') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ companies.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </CompanyFilter>

    <CompanyList :pagination="pagination" :companies="companies" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import CompanyCreateAction from "@/components/company/CompanyCreateAction.vue";
import CompanyFilter from "@/components/company/CompanyFilter.vue";
import CompanyList from "@/components/company/CompanyList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    CompanyCreateAction,
    CompanyFilter,
    CompanyList,
  },
  data() {
    return {
      listPropertyName: 'companies',
      apiResource: `companies`,
      companies: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Companies'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'company';
    },
  },
};
</script>